import { t } from "@/i18n-js/instance";
import { ListingCard } from "./ListingCard";

interface CommunitySegmentListingCardProps {
  resources: Array<{ title: string; id: string }>;
}

export const CommunitySegmentListingCard = ({
  resources,
}: CommunitySegmentListingCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.community_segments")}
    resources={resources}
    emptyStateText={t(
      "help_widget.copilot.chat_card.no_community_segments_found",
    )}
    renderItem={segment => segment.title}
    getItemKey={segment => segment.id}
  />
);
